export const SOCKET_IO_SERVER = process.env.REACT_APP_SOCKET_IO_SERVER;
export const RTMP_SERVER = process.env.REACT_APP_RTMP_SERVER;
